import React from 'react';
import { Form } from '@bd-uikit-web/React/Form';
import bdAuth from '@bd-uikit-web/js-helpers/bdAuth';
import bdReq from '@bd-uikit-web/js-helpers/bdReq';
import rootDispatcher from '@bd-uikit-web/js-helpers/rootDispatcher';
import autobind from '@bd-uikit-web/js-helpers/autobind';
import {
  CardElement,
  //   CardNumberElement,
  //   CardExpiryElement,
  //   CardCVCElement,
  injectStripe
} from 'react-stripe-elements';

class StripeCheckoutFormNew extends React.Component {
  constructor() {
    super();
    const user = bdAuth.getUser();

    this.state = {
      user,
      sending: false
    };
  }

  showNotiBanner(type, message) {
    rootDispatcher.dispatch('NB:OPEN', {
      type,
      msg: message
    });
  }

  @autobind
  handleSubmit() {
    const { email } = this.props;
    this.setState({ sending: true });
    // add subscription
    this.props.stripe.createToken({ email }).then(({ token }) => {
      this.props.onToken(token);
    });

    // add card to user
    this.props.stripe.createToken({ email }).then(({ token }) => {
      const apiLink = `/users/${this.state.user.id}/cards`;

      bdReq.post(apiLink, token).then(({ success, body }) => {
        if (!success) {
          this.setState({ sending: false });
          return;
        }
      });
      return true;
    });
  }

  render() {
    return (
      <Form onSubmit={this.handleSubmit}>
        <div className="checkout-form col-12">
          <div className="row">
            <h4 className="h--lower h--spacing-sm h--medium-weight">Checkout</h4>
            <p>
              Thank you for the subscription to our streaming service. The below credit card checkout is for an annual
              payment of the Blackdove service. We hope you enjoy the service however if you have any questions please
              email us at <a href="mailto:support@blackdove.com">support@blackdove.com</a> or speak to your dealer.
              While you are able to cancel at any time for the following year, our service is an annually renewing. This
              payment is being processed by{' '}
              <a target="_blank" rel="noopener noreferrer" href="https://stripe.com">
                Stripe
              </a>
              .
            </p>
          </div>
          <div className="row row--push-btm-xs">
            <label class="form__desc-label" style={{ display: 'inline-block', padding: '10px 0' }}>
              <strong>Credit or debit card</strong>
            </label>
            <CardElement style={{ base: { fontSize: '16px' } }} />
          </div>
          <div className="row row--push-btm-xs" style={{ display: 'block', paddingBottom: '40px' }}>
            <div style={{ float: 'left' }} className="btn btn--dark btn--outlined" onClick={this.props.back}>
              Back
            </div>
            <button disabled={this.state.sending} style={{ float: 'right' }} className="btn" type="submit">
              {this.state.sending ? (
                <div style={{ fontSize: '1.2em' }} className="spinner spinner--small" />
              ) : (
                `Pay $${this.props.amount}`
              )}
            </button>
          </div>
        </div>
      </Form>
    );
  }
}

export default injectStripe(StripeCheckoutFormNew);
